module.exports = __webpack_public_path__ + "static/media/ice-cream-cone.470c082b.jpg";